import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { userPermissionsSelector } from '../../store1/user login data/user.login.data.slice.slector';
import NotAuthorized from '../../Routes1/NotAuthorised/notAuthorised';

const ProtectedRoute = ({ permission, children }) => {
    const userPermissions = useSelector(userPermissionsSelector);

    const allowed = useMemo(() => {
        if (!permission) {
            return true;
        }

        if (Array.isArray(permission)) {
            return permission.some((code) => userPermissions.includes(code));
        }

        return userPermissions.includes(permission);
    }, [permission, userPermissions]);

    if (!allowed) {
        return <NotAuthorized />;
    }

    return children;
};

export default ProtectedRoute;
